@import '../../styles/modals.css';
@import '../../styles/buttons.css';
@import '../../styles/skeleton.css';
@import '../../styles/form.css';


:host .tambr-modal-body {
  padding: 20px;
}

.password-hint {
  opacity: 0.9;
  font-size: 10px;
  margin-top: 3px;
  color: #666;
}
